// @flow

import common from './locales/es/common.json'

export const es = { common }

export default es
